import { Component } from '@grafikr/components';

export default Component((node, { onMounted }) => {
  onMounted(() => {
    document.documentElement.style.setProperty('--header-height', `${node.offsetHeight}px`);
  });
});
